import { Capacitor } from "@capacitor/core";
import { motion, useAnimation, useDragControls } from "framer-motion";
import { useContext, useRef } from "react";
import goTo from "../../../controllers/goTo";
import Context from "../../../Context";

const SwipeBack = ({ children }) => {
  const { currentRoute } = useContext(Context);
  const controls = useAnimation();
  const dragControls = useDragControls();
  const startXRef = useRef(0);

  if (currentRoute === "/") return children;
  if (Capacitor.getPlatform() !== "ios") return children;

  return (
    <motion.div
      // We do NOT enable automatic drag; we will start it programmatically
      drag="x"
      dragControls={dragControls}
      dragListener={false} // disable the default pointer listener
      dragConstraints={{ left: 0, right: 50 }}
      dragElastic={0.3}
      animate={controls}
      onTouchStart={(e) => {
        const x = e.touches[0].clientX;
        startXRef.current = x;

        console.log("x", x);
        // If touch starts near left edge, start the drag immediately for this pointer
        if (x <= 30) {
          console.log("STARTING..");
          // Pass the native event so framer-motion can hook into the current gesture
          dragControls.start(e);
        }
      }}
      onDragEnd={(_, info) => {
        if (startXRef.current <= 30 && info.offset.x > 100) {
          controls.start({
            x: 500,
            transition: { type: "spring", stiffness: 300 },
          });
          setTimeout(() => goTo(-1)(), 150);
        } else {
          controls.start({
            x: 0,
            transition: { type: "spring", stiffness: 300 },
          });
        }
      }}
      className="fixed inset-0 bg-white"
    >
      {children}
    </motion.div>
  );
};

export default SwipeBack;
